/* -------------------------------------------------------------------------- */
/*                                 Icon styles                                */
/* -------------------------------------------------------------------------- */

@import './bq-icon.variables';

:host {
  @apply inline-block;
}

/**
 * This class is added on packages/beeq/src/components/icon/helper/request.ts
 * See lines 42 and 58 for details.
 */
.bq-icon__svg {
  @apply scale-x-[--bq-icon--direction];
}
